import { Sidenav } from '@app/components/layout/sidenav/Sidenav';
import { useAuth } from '@app/core/auth/authentication/hooks';
import { ModulesNavLinks } from '@app/modules/ModulesNavLinks';
import { parseAsBoolean, useQueryState } from 'nuqs';

/**
 * App-wired sidenav: hidden in fullscreen query mode; nav links omitted for superadmin.
 */
export function AppSidenav() {
  const [isFullscreen] = useQueryState('fullscreen', parseAsBoolean);
  const { isSuperadmin } = useAuth();

  if (isFullscreen) {
    return null;
  }

  return <Sidenav>{isSuperadmin ? null : <ModulesNavLinks />}</Sidenav>;
}
